<template>
  <div class="brands-banner">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/ion-rangeslider/2.3.1/css/ion.rangeSlider.min.css"/>
    <div class="home-banners-box carousel slide" data-ride="carousel" id="budgetBannerCarousel" role="region">
      <div class="carousel-inner" v-if="images.homeBanners.length > 0">
        <div class="item" v-for="(banner, index) in images.homeBanners" :key="index" :class="[index === 0 ? activeClass: '']">
          <img :src="banner">
        </div>
      </div>
      <div class="carousel-inner" v-else>
        <div class="item" v-for="(preview, index) in bannerComponent.previews" :key="preview.index" :class="[index === 0 ? activeClass: '']">
          <img :src="preview.image">
        </div>
      </div>
      <a class="left carousel-control" href="#budgetBannerCarousel" role="button" data-slide="prev">
        <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="right carousel-control" href="#budgetBannerCarousel" role="button" data-slide="next">
        <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
    <div class="col budget-col">
      <h3 class="text-center section-header">Choose Your Budget</h3>
      <div class="price-range">
        <input type="text" class="js-range-slider" id="price-range-slider-banner" value="" />
      </div>
      <h4 class="vehicles-available text-center">
        <span>Vehicles Available:&nbsp;</span>
        <span class="vehicle-count">
          215
        </span><span class="loading">
        </span>
      </h4>
      <a class="btn btn-lg inventory-type-button-block price-range-btn" href="#">View Vehicles</a>
    </div>
  </div>
</template>

<script>
import 'ion-rangeslider';

export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand,
      activeClass: 'active',
      bodyComponents: this.$store.state.bodyComponents
    };
  },
  computed: {
    bannerComponent() {
      return this.bodyComponents.find(c => c.title === "Default Homepage Banner");
    }
  },
  mounted() {
    $("#price-range-slider-banner").ionRangeSlider({
      skin: "big",
      type: "double",
      min: 0,
      max: 100000,
      from: 0,
      to: 100000,
      prefix: "$"
    });
    (function() {
      var c = {
        init: function() {
          $('#budgetBannerCarousel').carousel()
        }
      }
      $(document).ready(c.init);
    })(jQuery);
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  #budgetBannerCarousel .carousel-control {
    width: 5%;
  }
  #budgetBannerCarousel {
    cursor: pointer;
    width: 100%;
  }
  #budgetBannerCarousel .item img, #budgetBannerCarousel .item {
    width: 100%;
  }
  .brands-banner .budget-col {
    padding: 15px 30px;
    background: #ddd;
    min-width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .brands-banner .budget-col .section-header {
    margin-bottom: 30px;
  }
  .brands-banner .budget-col .vehicles-available {
    margin: 15px auto;
  }
  .brands-banner .budget-col .btn {
    display: block;
    color: #fff;
    background: var(--primary-color);
    font-size: 18px;
    font-weight: 600;
    padding: 8px 30px;
    border-radius: 0;
    margin: 20px auto;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all .3s ease;
  }
  .brands-banner .budget-col .btn:hover {
    opacity: .7;
  }

  @media (min-width: 1200px) {
    .brands-banner {
      display: flex;
    }
  }
  @media (max-width: 1199px) {
    .brands-banner .budget-col {
      padding: 15px;
    }
    .brands-banner .budget-col .price-range {
      min-width: 400px;
      margin: auto;
    }
  }
  @media (max-width: 497px) {
    .brands-banner .budget-col .price-range {
      min-width: 280px;
      width: 100%;
    }
  }
</style>
